/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  reqInvoiceCalcData: {
    rebateProgramCode: '',
    planType: '',
    allManufacturers: 'Yes',
    quarter: null,
    manufacturerId: null,
    // userId: localStorage.getItem('logInUser'),
    runProcedure: '',
  },
  errorMessages: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.SET_REQ_INVOICE_DATA: {
      return { ...state, reqInvoiceCalcData: action.payload };
    }
    case actionTypes.GET_MANUFACTURERS_BY_REQ_INV_CAL: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.CALCULATE_INVOICE: {
      return { ...state, calculateInvoice: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrRIC: action.defaultQtrRIC };
    }
    case actionTypes.SET_ERROR_MESSAGES_REQ_INV_CAL: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_REQUEST_INVOICE_CALCULATION_STORE: {
      return { ...initilaState };
    }
    default:
      return state;
  }
};

export default reducer;
